import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["incomingAccDataDetails", "secondChanceToUseAI", "receiptForm"];

  connect() {
    this.hideFormIfIncomingAccountingData();
  }

  hideFormIfIncomingAccountingData() {
    if(this.hasIncomingAccDataDetailsTarget) {
      this.receiptFormTarget.classList.add('hidden')
      this.secondChanceToUseAITarget.classList.add('hidden')
    }
  }

  showManualInput(event) {
    this.incomingAccDataDetailsTarget.classList.add('hidden')
    this.receiptFormTarget.classList.remove('hidden')
    this.secondChanceToUseAITarget.classList.remove('hidden')
  }

  showAISpinner(event) {
    var buttonElement = event.target.closest('a');

    const buttonTextChanger = function(textIndex) {
      var spinnerTexts = this.dataset.spinnerText.split(';');
      this.innerHTML = spinnerTexts[textIndex];
      var nextIndex = 0;
      if(spinnerTexts[textIndex+1]) {
        nextIndex = textIndex+1;
      }
      setTimeout(buttonTextChanger, 1300, nextIndex);
    }.bind(buttonElement)

    if(buttonElement.classList.contains('spinner_w_text')) {
      event.stopPropagation()
      event.preventDefault()
    } else {
      buttonElement.classList.add('spinner_w_text');
      buttonTextChanger(0);
    }
  }
}